<template>
  <PageBreadcrumb
    :crumbs="[{
      label: 'Gestione Visualizzatori',
      link: '/visualizzatori'
    }, {
      label: form.uuid ? 'Modifica Visualizzatore' : 'Aggiungi nuovo Visualizzatore'
    }]"
  />
  <form autocomplete="off">
    <InputText
      v-model="form.email"
      :disabled="form.uuid"
      :error-fields="errorFields"
      name="email"
      :submitted="submitted"
    >
      Email
    </InputText>

    <SubmitButtons
      :create-and-back="createAndBack"
      :create-and-stay="createAndStay"
      :mode="form.uuid ? 'update' : 'create'"
      :pending="pending"
      :update-and-back="updateAndBack"
      :update-and-stay="updateAndStay"
    />
  </form>
</template>
    
<script setup>
import { reactive } from 'vue';

import InputText from '@/components/form/InputText.vue';
import SubmitButtons from '@/components/form/SubmitButtons.vue';
import PageBreadcrumb from '@/components/PageBreadcrumb.vue';
import useAxios from '@/composables/axios';
import useForm from '@/composables/form';

const props = defineProps({
  id: {
    required: false,
    type: String,
    default: null
  }
})

const axios = useAxios()

let form = reactive({ email: '' })

if (props.id) {
  const resp = await axios.get('/admin-user/' + props.id);
  form = reactive(resp.data)
}

const rules = {
  email: {
    type: 'email',
    max: 255,
    required: true
  }
}
const { submitted, pending, errorFields, createAndBack, createAndStay, updateAndBack, updateAndStay } = useForm(form, 'viewer-user', rules, {
  create: 'Visualizzatore creato con successo',
  update: 'Visualizzatore modificato con successo'
}, '/visualizzatori')

</script>
   
